import React from 'react'

import clsx from 'clsx'

import Rating from 'components/Rating'
import Tooltip from 'components/Tooltip'
import { useEventContext } from 'context/EventContext'

import classes from './FeatureDetail.module.scss'

/** @type {import("./types").default} */
const FeatureDetail = ({ hasAiSummary = false, feature, className }) => {
  const { sendEvent } = useEventContext()

  const tooltipText = feature?.definition

  const transformSentence = name => {
    const words = name.split(' ')

    return [words[0], ...words.slice(1).map(word => word.toLowerCase())].join(' ')
  }

  return (
    <div
      className={clsx('FeatureDetail', classes.root, { [classes.bulletPoints]: hasAiSummary }, className)}
      data-testid="feature-detail"
    >
      {!!tooltipText ? (
        <Tooltip
          placement="top"
          title={<div className={classes.tooltip}>{tooltipText}</div>}
          sendOnEnterEvents={() =>
            sendEvent({
              name: 'engagement_hover',
              engagementComponent: 'product_key-features',
              engagementDestination: 'show_feature-definition',
              engagementDetails: 'hover_feature',
            })
          }
        >
          <span className={classes.title}>{transformSentence(feature.name)}</span>
        </Tooltip>
      ) : (
        <span className={clsx(classes.title, { [classes.noHover]: !tooltipText })}>{feature.name}</span>
      )}

      <Rating.Link
        isCompact
        average={feature.avg_rating}
        totals={feature.cnt_rating}
        hideTotals={hasAiSummary}
        className={classes.noHover}
      />
    </div>
  )
}

export default FeatureDetail
